import React from "react";
import exploreandExperience1 from "../images/compliance_data.png";
import exploreandExperience2 from "../images/exploreandExperience2.png";
import exploreandExperience3 from "../images/exploreandExperience3.png";
// import exploreandExperience4 from "../images/exploreandExperience4.png";
import exploreandExperience4 from "../images/esg_data.png";
import exploreandExperience5 from "../images/exploreandExperience5.png";
import LeftRightCombo from "../common/LeftRightCombo";
import { useTranslation } from "react-i18next";

const ExploreandExperience = () => {
  const { t } = useTranslation();
  const data = [
    {
      // topSmallImg: smallImgFirstpage1,
      mainTitle: t("compliance_data"),
      subTitle: t("compliance_data_desc"),
      image: exploreandExperience1,
      buttonText: t("get_started"),
      topImgBackColor: "F8E8D0",
    },
    {
      // topSmallImg: smallImgFirstpage2,
      mainTitle: t("cost_of_compliance"),
      subTitle: t("cost_of_compliance_desc"),
      image: exploreandExperience2,
      buttonText: t("get_started"),
      topImgBackColor: "B0E0FD",
    },
    {
      // topSmallImg: smallImgFirstpage3,
      mainTitle: t("compliance_new_regulation"),
      subTitle: t("compliance_new_regulation_desc"),
      image: exploreandExperience3,
      buttonText: t("get_started"),
      topImgBackColor: "D8F2F2",
    },
    {
      // topSmallImg: smallImgFirstpage3,
      mainTitle: t("esg_reporting"),
      subTitle: t("esg_reporting_desc"),
      image: exploreandExperience4,
      buttonText: t("get_started"),
      topImgBackColor: "D8F2F2",
    },
    {
      // topSmallImg: smallImgFirstpage3,
      mainTitle: t("business_reporting"),
      subTitle: t("business_reporting_desc"),
      image: exploreandExperience5,
      buttonText: t("get_started"),
      topImgBackColor: "D8F2F2",
    },
  ];
  return (
    <div className="flex justify-center mt-[-20px]">
      <div className="xl:max-w-[1000px] 3xl:max-w-[1200px]">
        <div className="md:container md:mx-auto">
          <div className="text-[#141619] text-[22px] sm:text-[32px]  md:text-[35px] 3xl:text-[54px] font-[600] flex flex-col justify-center items-center">
            {/* <span>Your Premier Destination </span> */}
            <span className="md:leading-[63px] sora">{t("omni_benefits")}</span>
          </div>
        </div>
        {data &&
          data.map((item, index) => {
            return (
              <LeftRightCombo
                key={index}
                mainTitle={item.mainTitle}
                subTitle={item.subTitle}
                image={item.image}
                buttonText={item.buttonText}
                index={index}
                topSmallImg={item.topSmallImg}
                topImgBackColor={item.topImgBackColor}
                isHomePage={true}
              />
            );
          })}
      </div>
    </div>
  );
};

export default ExploreandExperience;
